/**
 * Wrapper class for window.setTimeout().
 */
export class Timer {
    /** true if timer was started */
    get isRunning() {
        return (this.mTimer != null);
    }
    constructor(pHandler) {
        this.onTimeout = () => {
            this.mTimer = null;
            this.mHandler();
        };
        this.mHandler = pHandler;
    }
    /**
     * Starts the timer. The handler will be executed only once if consecutive calls are
     * made before the timeout.
     * @param pTimeout Timeout in milliseconds for the timer.
     * @param pRestart If true and the timer is currently running, the timer will be restartet
     * with the new timeout. If false the currently running timer will
     * stay active and the new timeout is ignored. (default: false)
     */
    start(pTimeout, pRestart = false) {
        if (this.isRunning) {
            if (pRestart) {
                this.stop();
            }
            else {
                return; // do nothing
            }
        }
        this.mTimer = window.setTimeout(this.onTimeout, pTimeout);
    }
    /** stops the timmer if it is currently running */
    stop() {
        if (this.mTimer != null) {
            clearTimeout(this.mTimer);
            this.mTimer = null;
        }
    }
}
export default Timer;
